module.exports = __webpack_public_path__ + "img/香水.a7689c36.png";